import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Icon } from 'antd';
import cn from 'classnames';
import { requestsActions } from '../../requests.actions';
import { notificationConstants } from '../../../../constants/notification.constants';
import styles from './AddressFilterToggle.module.scss';

const AddressFilterToggle = ({ request }) => {
  const dispatch = useDispatch();

  const presetFilter = useSelector((state) => state.filterStore.presetFilter);
  const selected = useSelector((state) => state.filterStore.selected);

  const handleClick = (e) => {
    e.stopPropagation();

    if (!selected && presetFilter) {
      dispatch({
        type: notificationConstants.NOTIFICATION_CLEAR,
        payload: null,
      });
      dispatch(requestsActions.backFilter());
    } else {
      dispatch(requestsActions.setRequestAddressFilter(request));
    }
  };

  return (
    <div className={styles.root}>
      <span className={styles.container}>
        <span className={cn(styles.btnWrap, 'dspx-ref-show')}>
          <Tooltip
            title={
              presetFilter
                ? 'Отменить фильтр по адресу'
                : 'Применить фильтр по адресу'
            }
          >
            <Icon onClick={handleClick} type="filter" className={styles.icon} />
          </Tooltip>
        </span>
      </span>
    </div>
  );
};

export default AddressFilterToggle;
